<template>
  <div class="social-icons">
    <div class="caption">say haayy to bubly sparkling water</div>
    <ul>
      <li v-for="(item, i) in items" :key="i">
      <a class="network" :title="item.text" :href="item.link" target="blank">
        <VueIcon :name="item.icon"></VueIcon>
      </a>
    </li>
    <li>
      <a class="network" title="Giphy" href="https://giphy.com/bublywater" target="blank" aria-label="Giphy (opens in a new tab)">
      <custom-icon :link="Giphy"></custom-icon>
    </a>
    </li>
  </ul>
  </div>
</template>

<script>
  import VueIcon from 'vue-awesome/components/Icon';
  import CustomIcon from '@/components/custom-icons/Icon';
  import Giphy from '@/assets/giphy-logo.svg';

  export default {
    name: 'social',
    data() {
      return {
        items: [{
          icon: 'facebook-square',
          link: 'https://www.facebook.com/bublywater/',
          text: 'Facebook (opens in a new tab)',
        }, {
          icon: 'instagram',
          link: 'https://www.instagram.com/bublywater/',
          text: 'Instagram (opens in a new tab)',
        }, {
          icon: 'twitter-square',
          link: 'https://twitter.com/bublywater',
          text: 'Twitter (opens in a new tab)',
        }, {
          icon: 'youtube-square',
          link: 'https://www.youtube.com/channel/UC7xAT5b3Dgd40KipH7ZFdSQ/featured?disable_polymer=1',
          text: 'YouTube (opens in a new tab)',
        }],
        Giphy
      };
    },
    components: {
      VueIcon,
      CustomIcon
    },
  };
</script>

<style lang='scss' scoped>
  @import './../../variables.scss';

  .social-icons {
    color: $bubly-white;
    font-size: rem(18);
    display: flex;
    flex-direction: column;
    align-items: center;

    &>ul {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        margin-left: 14px;
       }
    }

    @include breakpoint('tablet') {
      font-size: rem(29);
    }
  }

  .caption {
    padding: 0 12px;
    font-size: rem(15);
    vertical-align: bottom;
    line-height: 2.3;

    @include breakpoint('tablet') {
      font-size: rem(21);
      padding-right: 0;
      line-height: rem(21);
      margin: 20px 0;

    }
  }

  .network {
    margin: 0 7px;
    padding: 5px;
    display: inline-block;
	  width: 25px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
  a[title='Giphy'] {
    display: inline-flex;
    margin-left: 0;
    padding: 0;
    width: 21px;
    height: 19px;
    @include breakpoint('tablet') {
      width: 29px;
      height: 30px;
    }
  }
  .large-icons {
    font-size: rem(43);
    position: relative;
    padding-left: 110px;
    display: inline-block;
    .caption {
      font-size: rem(21);
      font-weight: 600;
      text-transform: lowercase;
      position: absolute;
      top: 5px;
      left: 0;
    }
    .network {
      margin: 0 4px;
    }
  }

  .top-caption {
    font-size: rem(43);
    // margin-bottom: rem(20);
    .caption {
      display: block;
      text-transform: lowercase;
      font-size: rem(21);
    }

    a[title='Giphy'] {
      width: 41px;
      height: 43px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Social.vue